<template>
  <div>
    <div class="text-center titles font-weight-bold">
      მიუთითეთ პირადი ინფორმაცია
    </div>
    <b-form class="mt-3 pt-2">
      <b-input placeholder="სახელი, გვარი"
               v-model.trim="fullName"
               :autocomplete="'off'"
               class="mt-3 NotoSansGeorgian-Regular"
               v-bind:class="{ 'has-error': $v.fullName.$error }"/>
      <b-input placeholder="პირადი ნომერი"
               v-model.trim="idNumber"
               :autocomplete="'off'"
               class="mt-3 NotoSansGeorgian-Regular"
               v-bind:class="{ 'has-error': $v.idNumber.$error }"/>
      <b-input placeholder="ტელეფონის ნომერი"
               :autocomplete="'off'"
               v-model.trim="phone"
               type="number"
               class="mt-3 NotoSansGeorgian-Regular"
               v-bind:class="{ 'has-error': $v.phone.$error }"/>
    </b-form>
  </div>
</template>

<script>
import {required, minLength} from "vuelidate/lib/validators";
export default {
  name: "step-3",
  data() {
    return {
      fullName: this.$route.query.name || '' ,
      idNumber: this.$route.query.id || '',
      phone: this.$route.query.phone ||''
    }
  },
  validations:{
    fullName: {required},
    idNumber: {required, minLength: minLength(11)},
    phone: {required, minLength: minLength(9)}
  }
}
</script>

<style scoped>
.NotoSansGeorgian-Regular {
  font-size: 14px !important;
}

.form-control {
  height: calc(1.7em + .75rem + 2px) !important;
}

</style>